/** Keeps an unfinished name outside the document, even while the keyed list repaints. */
export class NativeLayerNames {
  private edit: {
    id: string;
    generation: number;
    input: HTMLInputElement;
    label: HTMLButtonElement;
  } | null = null;
  constructor(
    private list: HTMLElement,
    private generation: () => number,
    private commit: (id: string, name: string) => void,
  ) {}
  get active() {
    return this.edit !== null;
  }
  start(id: string, name: string) {
    if (this.edit?.id === id) return;
    this.finish(true);
    const label = Array.from(
      this.list.querySelectorAll<HTMLButtonElement>("[data-node-id]"),
    ).find((b) => b.dataset.nodeId === id);
    if (!label) return;
    const input = document.createElement("input");
    input.type = "text";
    input.className = "native-layer-name-input";
    input.setAttribute("aria-label", "Имя слоя");
    input.value = name;
    this.edit = { id, generation: this.generation(), input, label };
    label.hidden = true;
    label.after(input);
    input.onblur = () => this.finish(true);
    input.onkeydown = (event) => {
      if (event.key !== "Enter" && event.key !== "Escape") return;
      if (event.isComposing) return;
      event.preventDefault();
      event.stopPropagation();
      this.finish(event.key === "Enter");
      label.focus();
    };
    input.focus();
    input.select();
  }
  finish(commit: boolean) {
    const edit = this.edit;
    if (!edit) return;
    this.edit = null;
    edit.label.hidden = false;
    edit.input.remove();
    if (commit && edit.generation === this.generation())
      this.commit(edit.id, edit.input.value);
  }
  reconcile(ids: readonly string[]) {
    if (
      this.edit &&
      (this.edit.generation !== this.generation() ||
        !ids.includes(this.edit.id))
    )
      this.finish(false);
  }
}
